<div [ngClass]="getChatButtonsClass()">
  <div class="bc-border-top" [ngClass]="getButtonGroupsClass()">
    <div class="chat-button-group small-icons" *ngIf="hasFlagPermission || hasBlockChatPermission">
      <div class="small-icon" *ngIf="hasFlagPermission">
        <app-flag [workItemId]="workItemId" [workItemFlagState]="workItemFlaggedState"></app-flag>
      </div>
      <div
        class="small-icon"
        *ngIf="hasBlockChatPermission">
        <svg-icon
          id="chat-buttons-block"
          title="{{ 'bcChatButtons.block'| translate }}"
          class="block-icon"
          icon="block"
          (click)="onBlockChatClick()">
        </svg-icon>
      </div>
    </div>
    <div class="chat-button-group">
      <button *ngIf="hasWrapUps" class="btn btn-light" (click)="onWrapUpButtonClick()" id="chat-buttons-wrap-up">
        <span>{{ 'bcChatButtons.wrapupButton' | translate }}</span>
      </button>

      <button *ngIf="hasDiscussionsFeature" class="btn btn-light" (click)="onDiscussClick()" id="chat-buttons-discuss" [disabled]="isDiscussionOpened">
        <span>{{ 'bcChatButtons.discuss' | translate }}</span>
      </button>
    </div>

    <div class="chat-button-group chat-button-group-right">
      <div class="button-tooltip-container">
        <button class="btn btn-light js-open-chat-transfer-button" id="chat-buttons-transfer" (click)="onTransferButtonClick()" [disabled]="isTransferButtonDisabled">
          <span>{{ 'bcChatButtons.transferButton' | translate }}</span>
        </button>
        <ng2-tooltip direction="top" text="{{ 'bcChatBox.activeRcTransferDisabled' | translate }}" [hidden]="!isTransferButtonDisabled">
        </ng2-tooltip>
      </div>

      <button class="btn btn-light js-end-chat-button" id="chat-buttons-end-chat" *ngIf="isEndable" (click)="onEndChatClick()">
        <span>{{ 'bcChatButtons.endButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>
